import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { PRCInput } from '../controls/prcinput.js';
import { PRCDropDown } from '../controls/prcdropdown.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "../../css/main.css"


export function AdminEditMemberForm() {
    const location = useLocation();
    const [memberData, setMemberData] = useState([]);
    const [membershipTypeData, setMembershipTypeData] = useState([]);
    const [pageData, setPageData] = useState();
    const [dateStarted, setDateStarted] = useState(new Date());
    const [competencyData, setCompetencyData] = useState([]);
    const [membershipStatus, setMembershipStatus] = useState([]);
    const [memberStatus, setMemberStatus] = useState(0);
    const [memberType, setMemberType] = useState(0);
    const [familiesData, setFamilies] = useState([]);
    const [familyData, setFamily] = useState(0);
    const [userGroup, setUserGroup] = useState(0);
    const [userGroups, setUserGroups] = useState([]);
    const [pseudonymData, setPseudonymData] = useState('');
    const [supplimentaryData, setSupplimentaryData] = useState([]);
    const navigate = useNavigate();

    let first_render = useRef(true);

    const { MakeCall } = useAPICall();


    const handleMemberDataFetchForEdit = (data) => {
        setPageData(data);
        setMembershipTypeData(data.components['membershiptypes']);
        setMemberData(data.components['member']);
        setCompetencyData(data.components['competencytypes']);
        setMembershipStatus(data.components['membershipstatuses']);
        setMemberStatus(data.components['member'].idpeveril_status);
        setMemberType(data.components['member'].idpeveril_membership_type);
        setPseudonymData(data.components['pseudonyms']);
        let families = data.components['families'];
        families.push({'id':0, 'description':'NONE'});
        setFamilies(families);
        setFamily(data.components['member'].idpeveril_family);
        let usergroupname = data.components['usergroups'].find(el=> el.id === data.components['usergroup']);
        setUserGroup(usergroupname.id);
        setUserGroups(data.components['usergroups']);
        setDateStarted(new Date(data.components['member'].date_started));
        setSupplimentaryData(data.components["supplimentarydata"]);
        if(data.components['user_locked_out'] === 0)
        {
            document.getElementById('user_locked_out').checked = false;
        }
        else
        {
            document.getElementById('user_locked_out').checked = true;
        }
    }

    if (first_render.current === true) {
        let memberID = location.state.memberID;
        LoadMemberDataForEdit(memberID);

        first_render.current = false;
    }

    useEffect(() => {

    });

    function handleNav(destination, state) {
        navigate(destination, state);
    }
    function LoadMemberDataForEdit(id) {

        MakeCall('admin/getadminviewmemberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"idpeveril_member\" : \"" + id + "\"}", handleMemberDataFetchForEdit, false);
    }

    function handleMemberSaveComplete(data) {
        if (data.components['result'].succeeded === true) {
            navigate("/ViewMember", { state: { memberID: memberData.idpeveril_member } });
        }
    }


    function handleSaveMember() {
        const data_entry = document.getElementsByTagName("input");
        let request = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"";
        let comps = [];
        let supps = [];
        for (let i = 0; i < data_entry.length; i++) {
            if (data_entry[i].name === 'MEMBER_DATA') {
                request += ", \"" + data_entry[i].id + "\" : \"" + data_entry[i].value + "\"";
            }
            else if (data_entry[i].name === 'MEMBER_DATA_CHK') {
                const item = { "id": data_entry[i].id, "allowed": data_entry[i].checked === true };
                comps.push(item);
            }
            else if (data_entry[i].name === 'MEMBER_DATA_SUPP') {
                const item = { "id": data_entry[i].id, "value": data_entry[i].value, "supp_type" : "STRING" };
                supps.push(item);
            }
            else if (data_entry[i].name === 'MEMBER_DATA_SUPP_CHK') {
                const item = { "id": data_entry[i].id, "value": data_entry[i].checked === true, "supp_type" : "BOOL" };
                supps.push(item);
            }
            else if (data_entry[i].name === 'MEMBER_DATA_LOCK') {
                request += ", \"" + data_entry[i].id + "\" : \"" + (data_entry[i].checked === true) + "\"";
            }
        }
        request += ", \"date_started\" : \"" + dateStarted.toLocaleDateString() + "\"";
        const data_entry_drp = document.getElementsByTagName("select");
        for (let i = 0; i < data_entry_drp.length; i++) {
            if (data_entry_drp[i].name === 'MEMBER_DATA') {
                request += ", \"" + data_entry_drp[i].id + "\" : \"" + data_entry_drp[i].value + "\"";
            }
        }


        request += ", \"competencies\" : " + JSON.stringify(comps) ;
        request += ", \"supplimentary\" : " + JSON.stringify(supps) + "}";
        MakeCall('admin/updatemember', request, handleMemberSaveComplete, true);

    }


    function ShowCompetencies() {
        let result = [];
        for (let i = 0; i < competencyData.length; i++) {
            const competency_item = competencyData[i];
            if (memberData.competencies.find((competency) => { if (competency.idpeveril_competency_type === competency_item.id) { return competency } return '' })) {
                result.push(<div className='formrow' key={competency_item.id}>
                    <div className='formlabel'>{competency_item.description}</div>
                    <div className='formvalue'>
                        <input className='prccheckbox' type='checkbox' id={competency_item.id} defaultChecked='true' name='MEMBER_DATA_CHK' />
                    </div>
                </div>);
            }
            else {
                result.push(<div className='formrow' key={competency_item.id}>
                    <div className='formlabel'>{competency_item.description}</div>
                    <div className='formvalue'><input className='prccheckbox' type='checkbox' id={competency_item.id} name='MEMBER_DATA_CHK' /></div>
                </div>);
            }
        }
        return result;

    }
    function handleStatusChange(status) {
        setMemberStatus(status);
    }

    function handleTypeChange(type) {
        setMemberType(type);
    }
    function handleUserTypeChange(userTypeID) {
        setUserGroup(userTypeID);
    }
    function handleFamilyChange(family) {
        setFamily(family);
        if(family === '0')
        {
            setMemberType(2);
        }
        else
        {
            setMemberType(3);
        }
    }
    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/ViewMember", { state: { memberID: memberData.idpeveril_member } });
                break;
            case 'savechanges':
                handleSaveMember();
                break;
            default:
                break;
        }
    }

    function handleDelPseudonymComplete(data)
    {
        setPseudonymData(data.components['pseudonyms']);
    }
    function handleDeletePseudonym(idpeveril_member_pseudonym,idpeveril_member)
    {
        MakeCall('member/delpseudonym', "{ \"token\" : \"" + sessionStorage.getItem("Token") + 
        "\", \"idpeveril_member_pseudonym\" : \"" + idpeveril_member_pseudonym + 
        "\", \"idpeveril_member\" : \"" + idpeveril_member + "\"}",
        handleDelPseudonymComplete, true);
    }
    function ShowPseudonyms() {
        let result = [];
    
        if (pseudonymData.length > 0) {
          result.push(<div style={{ "height": "1em" }} />);
          result.push(<div className='formtitle'>Pseudonyms</div>);
          for (let i = 0; i < pseudonymData.length; i++) {
            result.push(<div className='gridrow' key={pseudonymData[i].idpeveril_member_pseudonym}>
              <div className='gridcell' style={{ "width": "75%" }}>{pseudonymData[i].pseudonym}</div>
              <div className='gridcell' style={{ "width": "25%" }}><button className='prcbtn' onClick={()=>{handleDeletePseudonym(pseudonymData[i].idpeveril_member_pseudonym,pseudonymData[i].idpeveril_member)}}>Delete</button></div>
            </div>);
          }
    
        }
    
        return result;
      }

      function ShowSupplimentaryData()
      {
        let result = [];
        if(supplimentaryData != null)
        {
        if (supplimentaryData.length > 0) {
         
          for (let i = 0; i < supplimentaryData.length; i++) {
            if(supplimentaryData[i].supplimentary_data_type === "BOOL")
            {
                if(supplimentaryData[i].data_value === "Y")
                {
                    result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
                    <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                        <div className='formvalue'>
                        <input className='prccheckbox' type='checkbox' id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} defaultChecked='true' name='MEMBER_DATA_SUPP_CHK' />
                        </div>
                    </div>);
                }
                else
                {
                    result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
                    <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                        <div className='formvalue'>
                        <input className='prccheckbox' type='checkbox' id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} name='MEMBER_DATA_SUPP_CHK'  />
                        </div>
                    </div>);
                }
            }
            else
            {
                result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
                <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                    <div className='formvalue'>
                    <PRCInput id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} value={supplimentaryData[i].data_value} className='logininput' name='MEMBER_DATA_SUPP' />
                    </div>
                </div>);
            }
      
          }
          
        }
        }
      
        return result;
      }

    return (

        <div>
            {SecurityElement(pageData)}
            {MenuForm()}
            <div className="contentdiv">
                {PageMenuElement("Edit Member", [{ "name": "Back", "onclick": "goback" },
                { "name": "Save Changes", "onclick": "savechanges" }], onPageMenuClick)}
                <div id='AdminEditMember' >                   
                    <div className='formbox'>
                        <div className='formtitle'>Details</div>
                        <div className='formrow'>
                            <div className='formlabel'>Status</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_status' className='logininput' options={membershipStatus} value={memberStatus} name='MEMBER_DATA' ownerID={memberData.idpeveril_member} onChange={handleStatusChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Number</div>
                            <div className='formvalue'>
                                <PRCInput id='membership_number' value={memberData.membership_number} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Type</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_membership_type' className='logininput' options={membershipTypeData} value={memberType} name='MEMBER_DATA' ownerID={memberData.idpeveril_member} onChange={handleTypeChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Forename</div>
                            <div className='formvalue'>
                                <PRCInput id='forename' value={memberData.forename} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Surname</div>
                            <div className='formvalue'>
                                <PRCInput id='surname' value={memberData.surname} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Family</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_family' className='logininput' options={familiesData} value={familyData} name='MEMBER_DATA' onChange={handleFamilyChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Start Date</div>
                            <div className='formvalue'>
                            {<DatePicker
                                showIcon
                                selected={dateStarted}
                                onChange={(date) => setDateStarted(date)}
                                name='date_started'
                                dateFormat="dd/MM/yyyy" />}
                            </div>
                        </div>
                        {ShowPseudonyms()}
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Contact Details
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Email</div>
                            <div className='formvalue'>
                                <PRCInput id='email' value={memberData.email} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>User Type</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_user_group' className='logininput' options={userGroups} value={userGroup} name='MEMBER_DATA' onChange={handleUserTypeChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>User Locked Out</div>
                            <div className='formvalue'>
                                <input className='prccheckbox' type='checkbox' id='user_locked_out' name='MEMBER_DATA_LOCK'/>
                            </div>
                        </div>                        
                        <div className='formrow'>
                            <div className='formlabel'>Mobile</div>
                            <div className='formvalue'>
                                <PRCInput id='mobile_number' value={memberData.mobile_number} className='logininput' name='MEMBER_DATA' /></div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Home</div>
                            <div className='formvalue'>
                                <PRCInput id='fixed_line_number' value={memberData.fixed_line_number} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                        Supplimatary Info
                        </div>          
                    {ShowSupplimentaryData()}
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Address
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>House / Number</div>
                            <div className='formvalue'>
                                <PRCInput id='house' value={memberData.house} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Street</div>
                            <div className='formvalue'>
                                <PRCInput id='street' value={memberData.street} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Area</div>
                            <div className='formvalue'>
                                <PRCInput id='area' value={memberData.area} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Town</div>
                            <div className='formvalue'>
                                <PRCInput id='town' value={memberData.town} className='logininput' name='MEMBER_DATA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Country</div>
                            <div className='formvalue'>
                                <PRCInput id='country' value={memberData.country} className='logininput' name='MEMBER_DATA' /></div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Postcode</div>
                            <div className='formvalue'>
                                <PRCInput id='postcode' value={memberData.postcode} className='logininput' name='MEMBER_DATA' /></div>
                        </div>
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Competencies
                        </div>
                        {ShowCompetencies()}
                    </div>

                </div>
            </div>
        </div>


    );
}


